import { getQuery } from './util.js';
import request from './request.js';
const url = 'https://marketing.chuanbaoguancha.cn/v1/auth/weixin';
let that = '';
class Authorization{
  constructor(cacheName){
    that = this;
    this.cacheName = cacheName;
  }
  Auth(params){
    // that = this;
    let type = params && params.type || '';
    let refresh = params && params.refresh || '';
    let authData = localStorage.getItem(that.cacheName);
    const query = getQuery();
    that.query = query;
    that.event_from = query.auth ?  query.auth.split('_')[0] : '';
    return new Promise(async (resolve, reject) => {
      if(refresh || !authData){
        query.code ? resolve(await that.httpAuth(type)) : that.redirectToWx();
      }else{
        authData = JSON.parse(authData);
        if(type == 'user'){ resolve(authData); return;}
        // let expires_in = type == 'token' ? authData.expires_in : authData.meta.custom.expires_in;
        let expires_in = authData.expires_in;
        let isExpired = expires_in - Date.now() < 400;
        isExpired ?  that.redirectToWx() : resolve(authData);
      }
    });
   
  }
  redirectToWx(){
    localStorage.removeItem(that.cacheName);
    var temp = window.location.href.split('?');
    let url = 'https://marketing.chuanbaoguancha.cn/auth/weixin?cus_callback=';
    url = url + temp[0] +'?auth=1_'+that.event_from;
    
    console.log('授权跳转地址：', url);
    window.location.href = url;
  }
  httpAuth(type){
    return new Promise((resolve, reject) => {
      request({
        url: url,
        headers:{ Accept: "application/json; charset=utf-8" },
        method: 'POST',
        data: {
          code: that.query.code,
          state: that.query.state || ''
        }
      }).then(res=>{
        history.replaceState(null, null, location.href.split('?')[0])
        res = res.data;
        let cacheData = '', 
        tempData = {
          user: {
              id: res.data.id,
              nickname: res.data.nickname,
              avatar: res.data.avatar,
              mobile: res.data.mobile,
              name: res.data.name
          },
          access_token: res.meta.custom.access_token,
          expires_in: Date.now() + res.meta.custom.expires_in*1000
        };
          // tempData = {
          //   data: {
          //       id: res.data.id,
          //       nickname: res.data.nickname,
          //       avatar: res.data.avatar,
          //       mobile: res.data.mobile,
          //       name: res.data.name
          //   },
          //   meta: {
          //     custom:{
          //       access_token: res.meta.custom.access_token,
          //       expires_in: Date.now() + res.meta.custom.expires_in*1000
          //     }
          //   }
          // }
        switch(type){
          case 'user':
            cacheData = tempData.user;
          break;
          case 'token':
            cacheData = {
              expires_in: tempData.expires_in,
              token: tempData.access_token
            }
          break;
          default:
            cacheData = tempData;
          break;
        }
        // that.cacheName = curUser;
        localStorage.setItem(that.cacheName, JSON.stringify(cacheData));
        resolve(cacheData);
      }).catch(err=>{ reject(err); });
    });
    
  }
}
export default Authorization;
